import React from 'react';
import v from 'vudu';
import { styles as s, colors } from 'stylesheet';
import Bird from 'components/svgs/Bird';
import Face from 'components/svgs/Face';
import Tick from 'components/svgs/Tick';

const localClasses = v({
  socialButton: {
    height: '46px',
    position: 'relative',
    width: '100%',
    backgroundColor: 'transparent',
    borderStyle: 'solid',
    borderRadius: '7px',
    padding: '13px 0px 10px 0px',
    margin: '0 0 24px 0',
    outline: 'none',
  },
  active: {
    backgroundColor: colors.byzantine,
    backgroundImage: `linear-gradient(-220deg, ${colors.byzantine} 0%, ${colors.razzmatazz} 100%)`,
    border: 'none'
  },
  tickContainer: {
    position: 'absolute',
    right: '-8px',
    top: '-4px',
    width: '28px',
    backgroundColor: 'white',
    height: '28px',
    borderRadius: '50%',
    border: `3px solid ${colors.nightRider}`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  tick: {
    stroke: 'green'
  },
  networkName: {
    '@composes': [s.pl1],
    paddingRight: '4px',
    fontWeight: 700
  },
  entryCount: {
    opacity: 0.8
  }
});

const renderTick = should => {
  if (!should) return;
  return (
    <div className={localClasses.tickContainer}>
      <Tick width={12} height={9} stroke={colors.razzmatazz} />
    </div>
  );
}


export default ({ variant, active, onClick }) => {
  let wrapper = localClasses.socialButton;
  if (active) wrapper += ` ${localClasses.active}`;

  if (variant === 'twitter') {
    return (
      <button className={wrapper} onClick={onClick}>
        {renderTick(active)}
        <Bird height={13} />
        <span className={localClasses.networkName}>Twitter</span>
        <span className={localClasses.entryCount}>+5 Entries</span>
      </button>
    );
  }
  return (
    <button className={wrapper} onClick={onClick}>
      {renderTick(active)}
      <Face height={13} />
      <span className={localClasses.networkName}>Facebook</span>
      <span className={localClasses.entryCount}>+5 Entries</span>
    </button>
  );
}



// WEBPACK FOOTER //
// ./src/components/SocialButton.js